import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import styled from "styled-components";
import axios from "api/axiosController";
import snack from "components/wrapper/snack";
import { New_Logo } from "assets2/images/images";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { appleloginStart, googleloginStart } from "redux/user";
import { FcGoogle } from "react-icons/fc";
import AppleIcon from "@mui/icons-material/Apple";
import { GoogleLogin } from "react-google-login";
import FirebaseTypes from "firebase";
import { firebaseForApple as firebase } from "../../../../../config/firebase";

// TODO: Add api to change image with popup

interface MailingListModalProps {
  open: boolean;
  onClose: () => void;
}

const MailingListModal: React.FC<MailingListModalProps> = ({
  open,
  onClose,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location: any = useLocation();

  const responseFromGoogle = (response: any) => {
    const token = response["tokenId"];
    if (location.state && location.state.buyNowFlow) {
      dispatch(
        googleloginStart({
          token,
          history,
          buyNowFlow: location.state.buyNowFlow,
          redirect: location.state?.redirect,
        })
      );
    } else
      dispatch(
        googleloginStart({ token, history, redirect: location.state?.redirect })
      );
  };

  const errorFromGoogle = (response: any) => {
    snack.error("Google Sign in failed");
    history.push("/");
  };

  const signInWithApple = async () => {
    var provider = new FirebaseTypes.auth.OAuthProvider("apple.com");
    provider.addScope("name");
    provider.addScope("email");
    try {
      const response = await firebase.auth().signInWithPopup(provider);
      console.log(response);
      if (response && response.user?.email) {
        if (location.state && location.state.buyNowFlow) {
          dispatch(
            appleloginStart({
              response,
              history,
              buyNowFlow: location.state.buyNowFlow,
              redirect: location.state?.redirect,
            })
          );
        } else {
          dispatch(
            appleloginStart({
              response,
              history,
              redirect: location.state?.redirect,
            })
          );
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <StyledBox>
        <CloseButton variant="text" onClick={onClose}>
          <CloseIcon style={{ color: "white" }} />
        </CloseButton>
        <Heading>
          <img src={New_Logo} alt="logo" style={{ width: "50%" }}  loading="lazy"/>
        </Heading>
        <Info>
          <p>Create an account to receive 5% off, coupons and discounts!</p>
        </Info>
        <AuthContainer>
          <div
            style={{
              display: "flex",
              gap: "10px",
              flexDirection: "column",
              alignItems: "center",
              marginBottom: "40px",
            }}
          >
            {/* Google Sign in */}
            <div
              style={{
                display: "flex",
                width: "80%",
                height: "48px",
                justifyContent: "center",
              }}
            >
              <GoogleLogin
                clientId="337705274204-gac97kappr7imkhg32ijarfdgv0jfp8o.apps.googleusercontent.com"
                onSuccess={responseFromGoogle}
                onFailure={errorFromGoogle}
                cookiePolicy={"single_host_origin"}
                render={(renderProps) => (
                  <GoogleButton
                    onClick={renderProps.onClick}
                    disabled={renderProps.disabled}
                    style={{ width: "100%" }}
                  >
                    <IconContainer>
                      <FcGoogle size={20} />
                    </IconContainer>
                    Sign in with Google
                  </GoogleButton>
                )}
              />
            </div>

            {/* Apple Sign In */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "80%",
                height: "48px",
              }}
            >
              <AppleButton
                onClick={signInWithApple}
                className="authProviderText"
              >
                <IconContainer>
                  <AppleIcon className="authProviderIcon" />
                </IconContainer>
                Sign in with Apple
              </AppleButton>
            </div>
            {/* Register with Email */}
            <div
              style={{
                display: "flex",
                width: "80%",
                height: "48px",
                justifyContent: "center",
              }}
            >
              <EmailButton
                onClick={() => {
                  history.push("/users/buyer/register");
                }}
                style={{ width: "100%" }}
              >
                <IconContainer>
                  <i className="fas fa-envelope"></i>
                </IconContainer>
                Register with Email
              </EmailButton>
            </div>
          </div>
        </AuthContainer>
      </StyledBox>
    </Modal>
  );
};

const StyledBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 400px;
  background-color: white;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 8px;
  outline: none;
`;

const Heading = styled.div`
  font-size: 1.75rem;
  font-weight: 400;
  color: #cfb53b;
  margin: 0;
  padding: 2rem;
  //background-color: hsl(122, 24%, 18%);
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Info = styled.div`
  padding: 0 2rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  font-weight: 600;
`;

const CloseButton = styled(Button)`
  position: absolute !important;
  top: 8px;
  right: 8px;
  width: fit-content;
  padding: 0;
  min-width: 0 !important;

  &:hover {
    background-color: transparent !important;
  }
`;

const GoogleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: grey;
  border-radius: 30px;
  border-width: 1.7px;
  width: full;
  padding: 6px;
  background-color: white;
  font-size: 1rem;
  color: black;
  font: inherit;
  &:hover {
    background: rgba(211, 211, 211, 0.3);
  }
  cursor: pointer;
`;

const AppleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: grey;
  border-radius: 30px;
  border-width: 1.7px;
  padding: 6px;
  background-color: white;
  font-size: 1rem;
  color: black;
  font: inherit;
  &:hover {
    background: rgba(211, 211, 211, 0.3);
  }
  cursor: pointer;
`;

const EmailButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: grey;
  border-radius: 30px;
  border-width: 1.7px;
  padding: 6px;
  background-color: white;
  font-size: 1rem;
  color: black;
  font: inherit;
  &:hover {
    background: rgba(211, 211, 211, 0.3);
  }
  cursor: pointer;
`;

const AuthContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  padding-top: 10px;
`;

const IconContainer = styled.span`
  display: flex;
  align-items: center;
  margin-right: 10px;
`;

export default MailingListModal;
